import { injectIntl } from "react-intl";
import React from "react";
import fileextension from "file-extension";
import moment from "moment";
import { Tooltip, Icon } from "antd";

function BoxData(props) {
  const { title, data, hide, showIconExclamation, iconTitle } = props;

  const style = hide ? { display: "none" } : {};
  return (
    <React.Fragment>
      <div style={style} className="box">
        <div className="bb-box-edit__i">
          <p>{title}</p>
        </div>
        <div className="bb-box-edit__d">
          <p>
            {data}
            {showIconExclamation && (
              <span>
                <Tooltip title={iconTitle}>
                  <Icon
                    type="exclamation-circle"
                    style={{ marginLeft: 10, color: "yellow" }}
                  />
                </Tooltip>
              </span>
            )}
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}
function CollectionMiddleViewAssetMetaData(props) {
  const { intl, itemSelected, showIconExclamation, user } = props;
  const { fileSizeFormat } = itemSelected;
  const copyrightDate = itemSelected.metadata.dueDate
    ? moment(itemSelected.metadata.createdDate)
        .utc()
        .format("DD/MM/YYYY") +
      " - " +
      moment(itemSelected.metadata.dueDate)
        .utc()
        .format("DD/MM/YYYY")
    : intl.formatMessage({ id: "undefined" });
  return (
    <React.Fragment>
      <div className="bb-box-edit__metadata">
        <div className="bb-box-edit__user">
          <div className="bb-box-edit__metainfo">
            <p> {intl.formatMessage({ id: "uploaded_by" })}</p>
          </div>
          <div className="bb-box-edit__metacontent">
            <div className="user">
              <p>{itemSelected.user ? itemSelected.user.name : ""}</p>
            </div>
          </div>
        </div>
        <div className="bb-box-edit__items">
          <div className="bb-box-edit__item">
            <BoxData
              title={intl.formatMessage({ id: "upload_date" })}
              data={moment(itemSelected.createdAt).format("DD/MM/YYYY")}
            />
            <BoxData
              title={intl.formatMessage({ id: "extension" })}
              data={"." + fileextension(itemSelected.originalURL)}
            />
          </div>
          <div className="bb-box-edit__item">
            <BoxData
              title={intl.formatMessage({ id: "copyright" })}
              data={copyrightDate}
              iconTitle={intl.formatMessage({ id: "asset_out_term" })}
              showIconExclamation={showIconExclamation}
            />
            <BoxData
              title={intl.formatMessage({ id: "original_weight" })}
              data={
                fileSizeFormat && fileSizeFormat !== ""
                  ? fileSizeFormat
                  : intl.formatMessage({ id: "unregistered" })
              }
            />
          </div>
          {itemSelected.viewFromHost && itemSelected.viewFromHost > 0 ? (
            <div className="bb-box-edit__item">
              <BoxData
                title={intl.formatMessage({ id: "bunkey_host_label" })}
                data={itemSelected.viewFromHost}
              />
            </div>
          ) : null}

          {user && user.role === "admin" && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                color: "#ffffff",
                fontSize: 14,
                lineHeight: "110%",
                marginBottom: 0,
              }}
            >
              <div>
                <p>UUID</p>
              </div>
              <div
                style={{
                  marginLeft: 10,
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onClick={() => navigator.clipboard.writeText(itemSelected.uuid)}
              >
                <p>{itemSelected.uuid}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default injectIntl(CollectionMiddleViewAssetMetaData);
